import Endereco from './endereco';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  changeEnderecoValueForm,
  getListEnderecoPaisAction,
  handleChangeTypeahead,
  getListEnderecoEstadoAction,
  setIdDDIPaisEndereco
} from '../../store/endereco/actions';

import {configuracaoDdi} from '../../store/ddi/actions';

const mapStateToProps = (state, nextState) => ({
  endereco: state.enderecoReducer,
  ddiReducer: state.ddiReducer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({

    changeEnderecoValueForm,
    getListEnderecoPaisAction,
    handleChangeTypeahead,
    getListEnderecoEstadoAction,
    setIdDDIPaisEndereco,
    configuracaoDdi
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Endereco);